import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function ClosingSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full px-4 py-20 bg-[#0f172a]" data-id="element-41">
      <div className="max-w-3xl mx-auto text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-43">
          <SparklesIcon className="w-16 h-16 text-yellow-400 mx-auto" data-id="element-44" />

          <div className="space-y-6 text-xl md:text-2xl text-gray-300" data-id="element-45">
            <p className="leading-relaxed" data-id="element-46">No te falta conocimiento.</p>
            <p className="text-3xl md:text-4xl font-black text-white" data-id="element-47">
              Te falta estructura.
            </p>
            <p className="leading-relaxed" data-id="element-48">Y eso…</p>
            <p className="text-3xl md:text-4xl font-black text-yellow-400" data-id="element-49">
              se soluciona hoy.
            </p>
          </div>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToCompra} className="bg-yellow-400/90 text-black px-12 py-6 rounded-xl font-black text-2xl shadow-lg shadow-yellow-400/40 hover:shadow-yellow-400/60 transition-shadow mt-12" data-id="element-50">
            EMPEZAR AHORA
          </motion.button>
        </motion.div>
      </div>
    </section>;
}